function chooseCard(){

    "use strict";

    var CHOOSECARD = '.choose-cards__item',
        FABRICCHOOSECARD = '.fabric-module__thumbs--item',
        ACTIVE_CHOOSECARD = 'choose-cards__active',
        SELECTOR_BAR = '.selector__bar',
        ZOOMIMAGE = '#fabric-module-zoom',
        ZOOMIMAGEBACKUP = '#fabric-module-zoom-backup',
        FABRICMODULE = '#fabric-module',
        FABRICMODULE_THUMBS = '.fabric-module__thumbs',
        FABRICTITLE = '.fabic-module__thumbs--title';

    function loadBackgroundFirst(url) {
        $('.fabric-module__image--loader').fadeIn();
        $(ZOOMIMAGE).imagesLoaded( { background: true} )
            .done( function( instance ) {
                $('.fabric-module__image--loader').hide();
                $( ZOOMIMAGE ).fadeTo( 96 , 1, function() {
                    $(ZOOMIMAGEBACKUP).css("background-image","url("+ url +")");
                    $(ZOOMIMAGE).css( "opacity", 0 );
                });
            })
    }

    $( CHOOSECARD ).on('click', onClick);

    function onClick(event) {
        if ( $(event.target).hasClass('icon-info') || $(event.target).parent().hasClass('icon-info') ) {
            return false;
        }
        if ( $(event.target).hasClass('choose-cards__item--more') || $(event.target).parent().hasClass('choose-cards__item--more') ) {
            // IF CLICKED ON RESIZE ICON
                var $tempTarget = $(this).data('target'),
                $newUrl = '/themes/studio-henk-v2/dist/assets/toolkit/images/fabric/large/'+ $tempTarget + '.jpg',
                $collection = $(this).data('collection'),
                $collectionValue = $collection.replace(/\-/g, ' '),
                $createTitle = $tempTarget.replace(/\-/g, ' ');
            $(ZOOMIMAGE).css("background-image","url("+ $newUrl +")");
            loadBackgroundFirst($newUrl);
            $(FABRICMODULE).modal("show");
            $('#fabric-module .selector__bar--value span:first-of-type').html($collectionValue);
            $('#' + $collection).prop('checked', true);
            $( FABRICMODULE_THUMBS + '[data-targetgroup="fabric-module-collection"]' ).each(function (index) {
                $(this).hide();
            });
            $( FABRICMODULE_THUMBS + '[data-target=' + $collection + ']' ).each(function (index) {
                $(this).show();
            });
            $( CHOOSECARD + '[data-targetgroup="fabric-module-card"]').each(function (index) {
                $(this).removeClass(ACTIVE_CHOOSECARD);
            });
            $( FABRICCHOOSECARD + '[data-target=' + this.getAttribute('data-target') + ']').each(function (index) {
                $(this).addClass(ACTIVE_CHOOSECARD);
            });
            $(FABRICTITLE).html($createTitle);
            // DON'T CHANGE CHOOSECARD ACTIVE STATE
            return false;
        }
        var $cardValue = this.getAttribute('data-value');
        $( CHOOSECARD + '[data-targetgroup=' + this.getAttribute('data-targetgroup') + ']').each(function (index) {
            $(this).removeClass(ACTIVE_CHOOSECARD);
        });
        $( SELECTOR_BAR + '[data-target=' + this.getAttribute('data-targetgroup') + ']').each(function (index) {
            $(this).find('.selector__bar--value span:first-of-type').html($cardValue);
        });
        $(this).toggleClass(ACTIVE_CHOOSECARD);
    }

}

module.exports = chooseCard;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/04_choose-card.js